<template>
  <div class="site-error">
    <h1 class="text-center">{{ realCode }}</h1>
    <div class="text-center" v-html="realMessage"></div>
  </div>
</template>
<script>
import mainMixin from '../mixins/mainMixin'
import ErrorMessagesEnum from '../enums/ErrorMessagesEnum'

export default {
  name: 'ErrorPage',
  mixins: [
    mainMixin
  ],

  props: {
    message: {
      type: String
    },
    code: {
      type: Number
    }
  },

  computed: {
    realMessage () {
      if (this.message) {
        return this.message
      }

      if (ErrorMessagesEnum[this.$route.query.cause]) {
        return ErrorMessagesEnum[this.$route.query.cause].message
      }

      return ErrorMessagesEnum.notFound.message
    },

    realCode () {
      if (this.code) {
        return this.code
      }

      if (ErrorMessagesEnum[this.$route.query.cause]) {
        return ErrorMessagesEnum[this.$route.query.cause].code
      }

      return ErrorMessagesEnum.notFound.code
    }
  }
}
</script>
